import ZoomOut from '../../src/legacy/ZoomOut';
export default ZoomOut;
